import { render } from "./UserGuideView.vue?vue&type=template&id=1fa7fe60&scoped=true"
import script from "./UserGuideView.vue?vue&type=script&lang=js"
export * from "./UserGuideView.vue?vue&type=script&lang=js"

import "./UserGuideView.vue?vue&type=style&index=0&id=1fa7fe60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa7fe60"]])

export default __exports__